import { render, staticRenderFns } from "./CreateRecipesModal.vue?vue&type=template&id=40ea1c0e&scoped=true&lang=pug"
import script from "./CreateRecipesModal.vue?vue&type=script&lang=js"
export * from "./CreateRecipesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateRecipesModal.vue?vue&type=style&index=0&id=40ea1c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea1c0e",
  null
  
)

export default component.exports